import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { isProduction } from '../../utility/config/environments.js'

const FooterContactViewConsultantTeam = ({
  icon,
  loginUrl,
  loginLabel,
  buttonOptionsText,
  contactUrl,
  contactLabel,
}) => {
  return (
    <div className="Footer-contactTop u-md-size6of12 u-lg-size6of12">
      <div className="Grid u-marginTop8gu">
        <div className="Footer-buttons u-lg-flex u-flexAlignItemsCenter u-textCenter">
          <span className="adel-material-symbols u-textSizeMsrp1 u-marginRight1gu u-alignBottom">
            {icon}
          </span>
          <a
            id="consultant-team-button"
            className="Link Footer-buttonsLink u-marginRight1gu u-posRelative hover-underline-animation"
            href={loginUrl}
          >
            <span className="u-hiddenVisually">{loginLabel}</span>
            {loginLabel}
          </a>
          <span className="Footer-buttonsText">{buttonOptionsText}</span>
          <a
            className="Link Footer-buttonsContact u-md-marginTop2gu u-sm-marginTop2gu u-posRelative hover-underline-animation"
            href={contactUrl}
          >
            <span className="u-hiddenVisually">{contactLabel}</span>
            <span className="Footer-buttonsCondensed">{contactLabel}</span>
            <span className="Icon--material u-textSizeMsrp1">
              chevron_right
            </span>
          </a>
        </div>
      </div>
    </div>
  )
}

export default function ErrorWrapperFooterContactViewConsultantTeam(props) {
  return (
    <ErrorBoundary
      fallbackRender={() =>
        !isProduction() ? (
          <p>Error in FooterContactViewConsultantTeam component</p>
        ) : null
      }
    >
      <FooterContactViewConsultantTeam
        {...props}
      ></FooterContactViewConsultantTeam>
    </ErrorBoundary>
  )
}
